// Employee helpers shared by client and server.
const { GROUP_ORDER } = require('./constants');

// Crew store experience per position; managers, shift leaders and drivers
// have a single exp field. Returns one comparable number either way.
function expFor(emp) {
    if (!emp) return 0;
    if (emp.exp !== undefined && emp.exp !== null) return Number(emp.exp) || 0;
    if (!emp.positions || emp.positions.length === 0) return 0;
    return Math.max(...emp.positions.map(p => p.experience || 0));
}

// Sort position for a group name; unknown groups fall to the end.
function groupRank(group) {
    const index = GROUP_ORDER.indexOf(group);
    return index === -1 ? GROUP_ORDER.length : index;
}

// Comparator for employee documents: group order, then roster order.
function byGroupThenOrder(a, b) {
    const diff = groupRank(a.group) - groupRank(b.group);
    if (diff !== 0) return diff;
    return (a.order ?? 999) - (b.order ?? 999);
}

module.exports = { expFor, groupRank, byGroupThenOrder };